<template>
 <ul class="px-[10px]">
    <BlockCard 
      v-for="value in blocks.items" 
      :key="value.id"
      :block="value" />
  </ul>
</template>

<script>
import BlockCard from '@/components/common/BlockCard.vue';

export default {
  name: 'AllBlocksList',
  components: {
    BlockCard,
  },
  props: {
    blocks: {
      type: Object,
      default: () => ({ items: [] })
    }
  }
}
</script>

<style scoped>
/* Component styles are handled by Tailwind classes */
</style>
